var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.348 490.348",
    style: {
      enableBackground: "new 0 0 490.348 490.348"
    },
    xmlSpace: "preserve",
    height: "1em",
    width: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M303.4,3.968l-168.9,116.8H46.9c-26.1,0-46.9,21.9-46.9,49v149.1c0,27.1,20.9,49,46.9,49h88.6l167.9,117.8 c18.8,12.3,33-4.7,32.3-15.6v-449.4C336.8,13.068,323.7-7.932,303.4,3.968z M40.7,319.868v-149.1c0-5.2,3.1-8.3,6.3-8.3h74v165.8 H47C43.8,328.268,40.7,324.068,40.7,319.868z M295.1,431.468l-132.4-92.5v-187.2l132.4-92.5V431.468z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.3,108.268c-4.2-11.5-15.6-16.7-26.1-13.6c-11.5,4.2-16.7,15.6-13.6,26.1c1,1,36.5,114.7,0,264.8 c-3.1,11.5,3.1,21.9,14.6,25c11.4,4.5,22.9-5.2,25-14.6C511.9,234.368,474.4,113.468,472.3,108.268z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.8,173.968c-11.5,4.2-16.7,15.6-13.6,26.1c1,0,14.6,45.9,0,106.3c-3.1,11.5,3.1,21.9,14.6,25c12.2,4,22.9-5.2,25-15.6 c17.7-70.9,1-126.1,0-128.2C408.7,176.068,397.2,170.768,386.8,173.968z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.a1c6bd19.svg";
export { ForwardRef as ReactComponent };